// extracted by mini-css-extract-plugin
module.exports = {"orderHistoryCard":"KB","cardHeader":"LB","orderDate":"MB","orderIdRow":"NB","orderPrice":"OB","melodyCarousel":"PB","cardAction":"QB"};